"use client";

import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export default function TransferHero() {
  return <section id="bookyourprivatetransferhero" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border/60">
      <div className="max-w-[1136px] mx-auto px-6">
        <motion.div className="max-w-2xl mx-auto text-center flex flex-col items-center" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }}>
          {/* Signature ornament */}
          <motion.div variants={itemVariants} className="flex items-center justify-center gap-2 mb-6" aria-hidden="true">
            <span className="size-2 bg-primary rounded-xs" />
            <span className="w-12 h-px bg-border" />
          </motion.div>

          {/* Page Headline */}
          <motion.h1 variants={itemVariants} className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground text-balance">
            Privattransfer anfragen
          </motion.h1>

          {/* Supporting Line */}
          <motion.p variants={itemVariants} className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed text-balance">
            Senden Sie uns Ihre Reisedaten für einen privaten Transfer oder kontaktieren Sie uns direkt, um Ihre Fahrt abzustimmen.
          </motion.p>

          {/* Primary CTA Button */}
          <motion.div variants={itemVariants} className="mt-8">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-medium px-6 py-2.5 shadow-sm">
              <Link to="#request-your-private-transfer" className="inline-flex items-center gap-2">
                <span>Jetzt buchen</span>
                <ArrowDown className="size-4" />
              </Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}